var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"fill-colored-el","d":"M8.5 4a1 1 0 011-1h1a1 1 0 011 1H14a1 1 0 011 1v1H5V5a1 1 0 011-1h2.5z","fill":"#333","key":0}),React.createElement("path",{"className":"fill-colored-el","fillRule":"evenodd","clipRule":"evenodd","d":"M5 7h10l-.91 9.1a1 1 0 01-.995.9h-6.19a1 1 0 01-.995-.9L5 7zm2.5 1.5a.5.5 0 011 0v7a.5.5 0 01-1 0v-7zM10 8a.5.5 0 00-.5.5v7a.5.5 0 001 0v-7A.5.5 0 0010 8zm1.5.5a.5.5 0 011 0v7a.5.5 0 01-1 0v-7z","fill":"#333","key":1})]);
}

Trash.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Trash;

Trash.default = Trash;
